import { TimePicker as AntdTimePicker } from 'antd';

import { TIME_FORMAT, TIME_PLACEHOLDER } from './constants';

const TimePicker = ({ ...props }) => {
  return <AntdTimePicker {...props} size="large" format={TIME_FORMAT} minuteStep={15} placeholder={TIME_PLACEHOLDER} />;
};

export default TimePicker;
